import { Outlet } from 'react-router-dom'
import Header from '../components/usables/Header'
import DashSideNav from '../components/usables/DashSideNav'

export default function DashLayout() {
  return (
    <>
    <Header />
    <DashSideNav />
    <main className='md:p-3 md:overflow-y-auto md:ml-60 h-[calc(100vh-5.625rem)]'>
      <Outlet />
    </main>
    </>
  )
}